import { render, staticRenderFns } from "./PriceListAdd.vue?vue&type=template&id=5845d5af&"
import script from "./PriceListAdd.vue?vue&type=script&lang=js&"
export * from "./PriceListAdd.vue?vue&type=script&lang=js&"
import style0 from "./PriceListAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports